import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VitalHttpServices } from 'src/app/core/services/VitalHttpServices';
import { catchError, map, of } from 'rxjs';

@Component({
  selector: 'app-manage-payer-library-lookup',
  templateUrl: './manage-payer-library-lookup.component.html',
  styleUrls: ['./manage-payer-library-lookup.component.scss']
})
export class ManagePayerLibraryLookupComponent implements OnInit {
  searchData: boolean = false;
  isShimmer: boolean = false;
  isSelected: boolean = false;
  selectedIndex: number = -1;
  radioChecked: number = -1;

  PayerList: any[] = [];
  responseData: any;
  GridData: boolean = false;
  truncatedCells: Set<string> = new Set();
  importData: any[] = [];

  LookupForm = this._fb.group({
    payerName: ['', Validators.required],
    electronicPayerId: [''],
    addressandcontact: [true]
  });

  private deploymentkey: string = '';

  constructor(
    private _fb: FormBuilder,
    private vitalHttpServices: VitalHttpServices,
    private _snackbar: MatSnackBar,
    private _dialogRef: MatDialogRef<ManagePayerLibraryLookupComponent>,
    private ngxService: NgxUiLoaderService,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public config: any,
  ) {}
  ngOnInit(): void {
    this.deploymentkey = sessionStorage.getItem('deploymentKey');
    this.LookupForm.patchValue({
      payerName: this.config.prefilledData?.payerName || '',
      electronicPayerId: this.config.prefilledData?.electronicPayerId || '',
      addressandcontact: this.config.prefilledData?.addressandcontact !== undefined ? this.config.prefilledData.addressandcontact : true
    });

    const payerName = this.config.prefilledData?.payerName;
    if (payerName && payerName.toString().trim() !== '') {
      setTimeout(() => this.fetchMDMData(), 300);
    }
  }

  get isLookupButtonDisabled(): boolean {
    const payerName = this.LookupForm?.controls?.payerName?.value;
    return !payerName || payerName.toString().trim() === '';
  }

  returnBtn(): void {
    this._dialogRef.close();
  }

  fetchMDMData(): void {
    this.searchData = true;
    this.isShimmer = true;
    this.isSelected = false;
    this.selectedIndex = -1;
    this.truncatedCells.clear();
    
    const fetchobj = {
      payerName: this.LookupForm.controls.payerName.value,
      electronicPayerId: this.LookupForm.controls.electronicPayerId.value,
      state: '',
      city: '',
      zip: ''
    };
    this.ngxService.start('SearchPayer');
    this.vitalHttpServices.getMDMPayerList(fetchobj, this.deploymentkey)
      .pipe(
        map(data => {
          this.ngxService.stopAll();
          if (data?.content && Array.isArray(data.content) && data.content.length > 0) {
            this.isShimmer = false;
            this.PayerList = data.content.slice();
            this.GridData = false;
            setTimeout(() => this.checkAllCellsTruncation(), 100);
          } else {
            this.isShimmer = false;
            this.PayerList = [];
            this.GridData = true;
          }
          return data;
        }),
        catchError(error => {
          this.ngxService.stopAll();
          this.isShimmer = false;
          this.PayerList = [];
          this.GridData = true;
          console.error("Error fetching payer list:", error);
          return of([]);
        })
      )
      .subscribe();
  }

  markRadio(index: number): void {
    const radio = document.getElementById('rad' + index) as HTMLInputElement;
    if (radio) {
      radio.checked = true;
    }
  }

  handleRowClick(index: number, item: any, event: any): void {
    // Only trigger if the click wasn't on the radio button itself
    if (event.target.type !== 'radio') {
      // Set selectedIndex first to prevent blinking
      this.selectedIndex = index;
      this.markRadio(index);
      this.selectedRadioButton(event, item);
    }
  }

selectedRadioButton(event: any, item: any): void {
  if (event != null) {
    const index = this.PayerList.indexOf(item);
    this.responseData = item;
    this.selectedIndex = index;
    this.isSelected = true;
    this.radioChecked = index;
    
    // Clear both lowercase and capitalized versions to ensure compatibility (same as saveData)
    if (this.LookupForm.controls.addressandcontact.value == false) {
      item.address1 = '';
      item.Address1 = '';
      item.address2 = '';
      item.Address2 = '';
      item.city ='';
      item.City ='';
      item.state='';
      item.State='';
      item.zip='';
      item.Zip='';
      item.phone = '';
      item.Phone = '';
      item.email = '';
      item.Email = '';
      item.fax = '';
      item.Fax = '';
    }
    
    this.importData = [];
    this.importData.push(item);
  }
  }

  saveData(): void {
    if (!this.isSelected) {
      this._snackbar?.open('Please select the row', null, {
        panelClass: ['warning-snackbar']
      });
      return;
    }

    // Clear address and contact fields when toggle is ON (matching manage-payers-lookup behavior)
    // Clear both lowercase and capitalized versions to ensure compatibility
    if (this.LookupForm.controls.addressandcontact.value == false) {
      this.responseData.address1 = '';
      this.responseData.Address1 = '';
      this.responseData.address2 = '';
      this.responseData.Address2 = '';
      this.responseData.city ='';
      this.responseData.City ='';
      this.responseData.state='';
      this.responseData.State='';
      this.responseData.zip='';
      this.responseData.Zip='';
      this.responseData.phone = '';
      this.responseData.Phone = '';
      this.responseData.email = '';
      this.responseData.Email = '';
      this.responseData.fax = '';
      this.responseData.Fax = '';
    }

    // Match manage-payers-lookup pattern: push to importData and close with importData
    this.importData.push(this.responseData);
    this._dialogRef.close(this.importData);
  }

  isTruncated(cellId: string): boolean {
    return this.truncatedCells.has(cellId);
  }

  checkAllCellsTruncation(): void {
    setTimeout(() => {
      this.PayerList.forEach((item, index) => {
        const checkCell = (cellId: string) => {
          const element = document.querySelector(`[data-cell-id="${cellId}${index}"]`) as HTMLElement;
          if (element) {
            // Check the <b> tag inside the span for truncation (where the actual text is)
            const textElement = element.querySelector('b') as HTMLElement;
            const elementToCheck = textElement || element;
            if (elementToCheck && elementToCheck.scrollWidth > elementToCheck.clientWidth) {
              this.truncatedCells.add(`${cellId}${index}`);
            } else {
              this.truncatedCells.delete(`${cellId}${index}`);
            }
          }
        };
        checkCell('payerName');
        checkCell('electronicPayerId');
        checkCell('payerFamily');
      });
      this.cdr.detectChanges();
    }, 200);
  }

  checkTruncation(event: MouseEvent, cellId: string): void {
    const target = event.currentTarget as HTMLElement;
    if (target) {
      const textElement = target.querySelector('b') as HTMLElement;
      const elementToCheck = textElement || target;
      if (elementToCheck) {
        // Use setTimeout to ensure DOM is fully rendered and measurements are accurate
        // setTimeout(() => {
        if (elementToCheck.scrollWidth > elementToCheck.clientWidth) {
          this.truncatedCells.add(cellId);
        } else {
          this.truncatedCells.delete(cellId);
        }
        this.cdr.detectChanges();
        // }, 0);
      }
    }
  }
}
